var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5C9.44772 5 9 5.44772 9 6V42C9 42.5523 9.44772 43 10 43H38C38.5523 43 39 42.5523 39 42V6C39 5.44772 38.5523 5 38 5H10ZM13.32 10C13.1433 10 13 10.0895 13 10.2V12.8C13 12.9105 13.1433 13 13.32 13H14.6H28.68C28.8567 13 29 12.9105 29 12.8V10.2C29 10.0895 28.8567 10 28.68 10H13.32ZM13 18.2C13 18.0895 13.1433 18 13.32 18H28.68C28.8567 18 29 18.0895 29 18.2V20.8C29 20.9105 28.8567 21 28.68 21H14.6H13.32C13.1433 21 13 20.9105 13 20.8V18.2ZM13.32 26C13.1433 26 13 26.0895 13 26.2V28.8C13 28.9105 13.1433 29 13.32 29H14.6H28.68C28.8567 29 29 28.9105 29 28.8V26.2C29 26.0895 28.8567 26 28.68 26H13.32ZM14 35V38H14.6H28V35H14ZM13 34.3333C13 34.1492 13.1433 34 13.32 34H28.68C28.8567 34 29 34.1492 29 34.3333V38.6667C29 38.8508 28.8567 39 28.68 39H14.6H13.32C13.1433 39 13 38.8508 13 38.6667V34.3333ZM32 10.4C32 10.1791 32.0358 10 32.08 10H35.92C35.9642 10 36 10.1791 36 10.4V15.6C36 15.8209 35.9642 16 35.92 16H32.4H32.08C32.0358 16 32 15.8209 32 15.6V10.4ZM32.08 18C32.0358 18 32 18.1791 32 18.4V23.6C32 23.8209 32.0358 24 32.08 24H32.4H35.92C35.9642 24 36 23.8209 36 23.6V18.4C36 18.1791 35.9642 18 35.92 18H32.08Z",
    fill: "#039BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVending);
export default ForwardRef;